export const DEFAULT_DROP_DOWN_BUTTON = 'overall'
export const BUILDING_CATEGORY = 'Buildings'
export const INDUSTRY_CATEGORY = 'Industry'
export const POPULATION_CATEGORY = 'Population'
export const MOBITLIY_CATEGORY = 'Mobility'
export const POTENTIAL_CATEGORY = 'R.E.S. Potential'
export const GEOTHERMAL_CATEGORY = 'Geothermal'
export const CLIMATE_CATEGORY = 'Climate'
export const ELECTRICITY_CATEGORY = 'Electricity'
export const FACILITIES_CATEGORY = 'Facilities'
export const WASTE_CATEGORY = 'Waste'
export const DECHETS_COLLECTE_TRAITEMENT = 'Sites'

export const CM_CATEGORY = {
  name: 'Calculation modules',
  ref: 'Calculation module',
}

//@todo, make a map or object but not an array
export const DROP_DOWN_RESULT_LIST = [
  {
    name: 'Results overview',
    ref: DEFAULT_DROP_DOWN_BUTTON,
  },
  { name: BUILDING_CATEGORY, ref: BUILDING_CATEGORY },
  { name: INDUSTRY_CATEGORY, ref: INDUSTRY_CATEGORY },
  { name: POPULATION_CATEGORY, ref: POPULATION_CATEGORY },
  { name: MOBITLIY_CATEGORY, ref: MOBITLIY_CATEGORY },
  { name: POTENTIAL_CATEGORY, ref: POTENTIAL_CATEGORY },
  { name: GEOTHERMAL_CATEGORY, ref: GEOTHERMAL_CATEGORY },
  { name: CLIMATE_CATEGORY, ref: CLIMATE_CATEGORY },
  { name: ELECTRICITY_CATEGORY, ref: ELECTRICITY_CATEGORY },
  { name: FACILITIES_CATEGORY, ref: FACILITIES_CATEGORY },
  { name: WASTE_CATEGORY, ref: WASTE_CATEGORY },
]
